import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Search, X } from "lucide-react";
import { useDeferredValue, useEffect, useState } from "react";
import { useDataTable } from "@/components/custom/table/data-table";
import { DataTableViewOptions } from "@/components/custom/table/data-table-view-options";

export function DataTableToolbar() {
  const table = useDataTable();
  const [searchValue, setSearchValue] = useState("");
  const deferredSearchValue = useDeferredValue(searchValue);

  // Apply search filter to the table
  useEffect(() => {
    table.getColumn("name")?.setFilterValue(deferredSearchValue || undefined);
  }, [deferredSearchValue, table]);

  const isFiltered = Boolean(searchValue);

  const resetFilters = () => {
    setSearchValue("");
  };

  return (
    <div className="flex items-center gap-4">
      <div className="relative max-w-sm flex-1">
        <Search className="absolute top-2 left-2 h-4 w-4 text-muted-foreground" />
        <Input
          className="h-8 pl-8"
          onChange={(event) => setSearchValue(event.target.value)}
          placeholder="Search by name..."
          value={searchValue}
        />
      </div>
      {!!isFiltered && (
        <Button
          className="h-8 px-2 lg:px-3"
          onClick={resetFilters}
          variant="warning"
        >
          Reset
          <X className="ml-2 size-4" />
        </Button>
      )}

      <DataTableViewOptions table={table} />
    </div>
  );
}
